import { combineReducers } from 'redux';
import landscape from './landscape';
import app from './app';
import freestyle from './freestyle';

const rootReducer =  combineReducers({
  landscape,
  freestyle,
  app,
})

export default rootReducer

export type GlobalState = ReturnType<typeof rootReducer>